var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "block-editor ideasoft-order-status" },
    [
      !_vm.channel
        ? _c(
            "section",
            [
              _c("a-result", {
                attrs: {
                  status: "warning",
                  title: "Ideasoft API not connected",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extra",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex align-items-center justify-content-center",
                            },
                            [
                              _c(
                                "SupsisButton",
                                {
                                  attrs: { primary: "", ghost: "" },
                                  on: { click: _vm.gotoIdeasoft },
                                },
                                [_vm._v(" Connect to Ideasoft")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  3553788062
                ),
              }),
            ],
            1
          )
        : [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "ideasoft-order-status-wrapper" }, [
              _c("div", { staticClass: "inputTitle" }, [
                _vm._v("Ideasoft Sipariş ID"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-editor-wrapper" },
                [
                  _c("TiptapEditor", {
                    attrs: {
                      "show-attributes": true,
                      "max-character-count": 64,
                      "show-emoji": false,
                      placeholder: "Üye ID",
                      rows: 1,
                    },
                    model: {
                      value: _vm.clone.orderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.clone, "orderId", $$v)
                      },
                      expression: "clone.orderId",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "inputTitle mt-5 mb-2 font-weight-bold" },
              [_vm._v(_vm._s(_vm.$t("chatbotv2.followingAttributesFilled")))]
            ),
            _vm._v(" "),
            _c(
              "section",
              { staticClass: "next-step-filled-items-wrapper" },
              _vm._l(_vm.nextStepFilledValue, function (attr) {
                return _c(
                  "div",
                  { key: attr, staticClass: "logos middle-section" },
                  [
                    _c("AttributeIconPreview", { attrs: { attribute: attr } }),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "ml-2" },
                      [_c("AttributeLabel", { attrs: { attribute: attr } })],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "active-connection" }, [
      _c("div", { staticClass: "logos", attrs: { "data-small": "true" } }, [
        _c("div", { staticClass: "logo1" }, [
          _c("img", {
            staticClass: "custom-block-logo",
            attrs: { src: "/static/img/supsis-logo2.png" },
          }),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "material-icons" }, [_vm._v(" add ")]),
        _vm._v(" "),
        _c("div", { staticClass: "logo2" }, [
          _c("img", { attrs: { src: "/static/img/ideasoft.webp" } }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "active-connection-text" }, [
        _c("div", [
          _c("span", [_vm._v("Connected with")]),
          _vm._v(" "),
          _c("b", [_vm._v("Ideasoft")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }